import React, { useState, useEffect } from "react";
import { Icon } from "antd";
import Button from "../Button";
import "./index.less";
const SortCtrl = ({ index, value, onChange }) => {
  const handleChange = (v) => {
    if (v === Infinity) {
      value.splice(index, 1);
      onChange([...value]);
    }
    if (v === -1) {
      let t = value[index];
      value.splice(index, 1);
      value.splice(index - 1 > 0 ? index - 1 : 0, 0, t);
      onChange([...value]);
    }
    if (v === 1) {
      let t = value[index];
      value.splice(index, 1);
      value.splice(index + 1, 0, t);
      onChange([...value]);
    }
  };
  return (
    <div className="TUI-ArrayCtrl-Handler">
      <Icon
        type="arrow-up"
        onClick={() => {
          handleChange(-1);
        }}
      ></Icon>
      <Icon
        type="arrow-down"
        onClick={() => {
          handleChange(1);
        }}
      ></Icon>
      <Icon
        style={{
          visibility:
            index <= 0 && (!value || value.length <= 1) ? "hidden" : "visible",
        }}
        type="minus"
        onClick={() => {
          handleChange(Infinity);
        }}
      ></Icon>
    </div>
  );
};
const DefaultPlus = ({ onClick }) => {
  return <Button onClick={onClick}>添加</Button>;
};
const DefaultCtrl = ({ value, index, onChange }) => {
  return (
    <div style={{ flexShrink: 0 }}>
      <a
        style={{ paddingLeft: 10 }}
        onClick={() => {
          if (value && value.length) {
            value.splice(index + 1, 0, null);
            onChange([...value]);
          } else {
            onChange([null]);
          }
        }}
      >
        新增
      </a>
      <a
        style={{
          paddingLeft: 10,
          visibility:
            index <= 0 && (!value || value.length <= 1) ? "hidden" : "visible",
        }}
        onClick={() => {
          value.splice(index, 1);
          onChange([...value]);
        }}
      >
        删除
      </a>
    </div>
  );
};
const ArrayCtrl =
  (Com, Plus = null, Ctrl = DefaultCtrl) =>
  (props) => {
    const { value = [null], onChange, opts } = props;
    const { disabled } = opts || {};
    const arr = (Array.isArray(value) ? value : [null]).map((item, i) => (
      <div className="TUI-ArrayCtrl-Item" key={i}>
        <Com
          {...props}
          value={item}
          onChange={(v) => {
            value[i] = v;
            onChange([...value]);
          }}
        />
        {disabled ? (
          <div />
        ) : (
          <Ctrl index={i} value={value} onChange={onChange} />
        )}
      </div>
    ));
    return (
      <div className="TUI-ArrayCtrl-Wrap">
        {arr}
        {disabled || !Plus ? null : (
          <div className="TUI-ArrayCtrl-Add">
            <Plus
              onClick={() => {
                onChange(value && value.length ? [...value, null] : [null]);
              }}
            />
          </div>
        )}
      </div>
    );
  };
ArrayCtrl.DefaultCtrl = DefaultCtrl;
ArrayCtrl.SortCtrl = SortCtrl;
ArrayCtrl.DefaultPlus = DefaultPlus;
export default ArrayCtrl;
